export default __webpack_public_path__ + "static/media/F2-female-02_mos_JLEE.25b93132.wav";